var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login", attrs: { id: "bloque1" } }, [
    _c("div", { staticClass: "loginBox" }, [
      _c("img", {
        staticClass: "loginBoxImg",
        attrs: { src: "/dist/logo-login.png" }
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "labels",
          staticStyle: {
            "font-weight": "400",
            "font-size": "20px",
            "margin-bottom": "0px"
          },
          attrs: { id: "titulo" }
        },
        [_vm._v("Sales registro")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "labels", attrs: { id: "info" } }, [
        _vm._v(
          "Si quiere ingresar al sistema necesitamos darlo de alta, por favor complete los siguientes datos y nos pondremos en contacto para darle acceso"
        )
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          on: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c("div", { staticClass: "container1" }, [
            _c("div", { staticClass: "container2" }, [
              _c("p", { staticClass: "labels" }, [_vm._v("NOMBRE")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.nombre,
                    expression: "nombre"
                  }
                ],
                staticClass: "inputBoxS",
                class: { inputBoxSInv: _vm.errorNombre },
                attrs: { type: "text" },
                domProps: { value: _vm.nombre },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.nombre = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container2",
                staticStyle: { "margin-left": "20px" }
              },
              [
                _c("p", { staticClass: "labels" }, [_vm._v("APELLIDO")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.apellido,
                      expression: "apellido"
                    }
                  ],
                  staticClass: "inputBoxS",
                  class: { inputBoxSInv: _vm.errorApellido },
                  attrs: { type: "text" },
                  domProps: { value: _vm.apellido },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.apellido = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "labels" }, [_vm._v("NOMBRE DEL COMERCIO")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nombreComercio,
                expression: "nombreComercio"
              }
            ],
            staticClass: "inputBoxL",
            class: { inputBoxLInv: _vm.errorNombreComercio },
            attrs: { type: "text" },
            domProps: { value: _vm.nombreComercio },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.nombreComercio = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "labels" }, [_vm._v("DIRECCIÓN")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.direccion,
                expression: "direccion"
              }
            ],
            staticClass: "inputBoxL",
            class: { inputBoxLInv: _vm.errorDireccion },
            attrs: { type: "text" },
            domProps: { value: _vm.direccion },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.direccion = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "container1" }, [
            _c("div", { staticClass: "container2" }, [
              _c("p", { staticClass: "labels" }, [_vm._v("EMAIL")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.email,
                    expression: "email"
                  }
                ],
                staticClass: "inputBoxS",
                class: { inputBoxSInv: _vm.errorEmail },
                attrs: { type: "email" },
                domProps: { value: _vm.email },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.email = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "container2",
                staticStyle: { "margin-left": "20px" }
              },
              [
                _c("p", { staticClass: "labels" }, [_vm._v("TELÉFONO")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.telefono,
                      expression: "telefono"
                    }
                  ],
                  staticClass: "inputBoxS",
                  class: { inputBoxSInv: _vm.errorTelefono },
                  attrs: { type: "text" },
                  domProps: { value: _vm.telefono },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.telefono = $event.target.value
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { id: "btnContainer" } }, [
            _c(
              "button",
              { attrs: { id: "btnCancelar" }, on: { click: _vm.btnCancelar } },
              [_vm._v("CANCELAR")]
            ),
            _vm._v(" "),
            _c(
              "button",
              { attrs: { id: "btnEnviar" }, on: { click: _vm.btnEnviar } },
              [_vm._v("ENVIAR")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66070664", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66070664","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/registro.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-66070664","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/login/registro.vue
// module chunks = 0